export default [
  {
    path: '/activity-20251212-pre-hot',
    component: () => import('./pre-hot.vue'),
    meta: { expire: '2026-01-31T23:59:59.000+08:00', title: '年度盛典预热页面', id: 7 },
  },
  {
    path: '/activity-20251212-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2026-01-31T23:59:59.000+08:00', title: '年度盛典', id: 8 },
  },
  {
    path: '/activity-20251212-rule',
    component: () => import('./rule.vue'),
    meta: { expire: '2026-01-31T23:59:59.000+08:00', title: '规则说明', id: 8 },
  },
  {
    path: '/activity-20251212-recharge',
    component: () => import('./recharge.vue'),
    meta: { expire: '2026-01-31T23:59:59.000+08:00', title: '累计充值', id: 10 },
  },
]
